import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { resolvePropertyProfile } from "../../../api/collingsData";

/**
 * An old per-source link (`/collings-data-properties/homer/:id`, `collings/:id`,
 * `owner/:key`, still in Re-listing rows, saved bookmarks and older search
 * results) opens the property's one profile instead (Christian Gravias,
 * Monday 12573204628, 26 Oct 2026: "the same Property ID rather than displayed
 * as separate records"). A property with no profile yet keeps its old page
 * (`fallback`).
 */
const PropertyProfileRedirect = ({ kind, fallback }) => {
    const { id, key } = useParams();
    const ref = id ?? key;
    const navigate = useNavigate();
    const [useFallback, setUseFallback] = useState(false);

    useEffect(() => {
        let cancelled = false;
        setUseFallback(false);
        resolvePropertyProfile({ [kind]: ref })
            .then((res) => {
                if (!cancelled) navigate(res.data.url, { replace: true });
            })
            .catch(() => {
                if (!cancelled) setUseFallback(true);
            });
        return () => {
            cancelled = true;
        };
    }, [kind, ref, navigate]);

    if (useFallback) return fallback;
    return (
        <div className="flex justify-center py-20">
            <Loader2 className="h-6 w-6 animate-spin text-[#55C5D0]" />
        </div>
    );
};

export default PropertyProfileRedirect;
